<div class="bg-th-yellow mt-0 container-fluid">

    <div class=" d-flex justify-content-between align-content-center h-35">

        <i class="fa fa-arrow-left text-dark my-auto pointer" (click)="goBack()"></i>

        <span class="my-auto f16 fw-bold me-2"> گزارش مالی </span>

    </div>

</div>

<main class=" rtl px-2 mt-2 p-2">

    <span class="px-2" *ngIf="list_financialReport.length > 0"> تعداد  <span class="text-danger fw-bold ">{{list_financialReport.length | faNum}}</span>  مورد یافت شد </span>

    <div class="row gx-2 mt-2 border border-2 p-2">

        <div class="col mt-3 mb-4">

            <input type="search" #search (input)="searchBy(search.value)" class="form-control" placeholder="جستجو کنید">

        </div>

        <div *ngIf="list_financialReport.length > 0" class="col-12 col-md-6 d-flex align-items-center justify-content-end">

            <button class="col btn btn-success mx-2" (click)="exportExcel()">
    
                <span> اکسل </span>
    
                <i class="fa fa-file-excel-o" aria-hidden="true"></i>
    
            </button>
         
            <button class="col btn btn-danger mx-2" (click)="message_Modal()" >
    
                <span> ارسال پیام </span>
    
                <i class="fa fa-envelope" aria-hidden="true"></i>
    
            </button>

            <button class="col btn btn-primary "  >
    
                <span> گزارش </span>
    
                <i class="fa fa-file-text-o" aria-hidden="true"></i>
    
            </button>

            <button class="col btn btn-warning mx-2"  >
    
                <span> چاپ </span>
    
                <i class="fa fa-print" aria-hidden="true"></i>
    
            </button>
    
        </div>

        <div class="table-responsive" style="max-height: 68vh;">

            <table class="table table-striped" id="Export_Excel">
    
                <thead class="position-sticky top-0 bg-white">
    
                    <tr class="col-12 text-center">

                        <th> # </th>
                        
                        <th (click)="selectAllCheckBox()" class="pointer">انتخاب</th>

                        <th> مدرسه </th>

                        <th> پایه </th>

                        <th> نام و نام خانوادگی </th>

                        <th> مبلغ کل بدهکاری </th>

                        <th> مبلغ کل بستانکاری </th>

                        <th> تراز </th>

                    </tr>
    
                </thead>
    
                <tbody>
    
                    <tr class="col-12 text-center" *ngFor="let item of list_financialReport;let i = index">
    
                        <th> {{ i + 1 | faNum }} </th>
    
                        <td><input type="checkbox" (change)="setCheckBox($event.target.checked,item)" [checked]="isSelected(item.iPassenger)"></td>
    
                        <td>{{item.strMobileDomain_strComment}}</td>

                        <td>{{item.strGrade}}</td>

                        <td>{{item.strPassenger_FullName}}</td>

                        <td>{{item.iDebit.toLocaleString() + ' ریال ' | faNum}}</td>

                        <td>{{item.iCredit.toLocaleString() + ' ریال ' | faNum}}</td>

                        <td>{{item.iBalance.toLocaleString() + ' ریال ' | faNum}}</td>

                    </tr>

                    <tr class="col-12 text-center " *ngIf="list_financialReport.length > 0 ">

                        <td></td>

                        <td></td>

                        <td></td>

                        <td></td>

                        <td class="fw-bold bg-gray"> جمع مبالغ :  </td>

                        <td class="fw-bold text-danger bg-gray">{{iTotalDebit.toLocaleString() + ' ریال ' | faNum}}</td>

                        <td class="fw-bold text-danger bg-gray">{{iTotalCredit.toLocaleString() + ' ریال ' | faNum}}</td>

                        <td class="fw-bold text-danger bg-gray">{{iTotalBalance.toLocaleString() + ' ریال ' | faNum}}</td>

                    </tr>
    
                </tbody>
    
            </table>
    
        </div>

    </div>



</main>

<!-- ارسال پیام  -->

<div class="modal fade" id="sendMessage" tabindex="-1" aria-labelledby="" aria-hidden="true" data-backdrop="false" data-keyboard="false">

    <div class="modal-dialog modal-dialog-centered modal-lg">

        <form #message="ngForm" (ngSubmit)="sendMessage(message)" class="modal-content p-1">

            <div class="modal-header dirI">

                <h5 class="modal-title"> ارسال پیام </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div dir="rtl" class="modal-body row gx-1 gy-2 w-100">

                <!-- متن پیام -->

                <div class="col-12 p-1">

                    <textarea class="form-control" style="resize: none;"
                    
                        ngModel name="strMessage"  cols="20" rows="7"
                        
                        placeholder="متن پیام خود را وارد کنید ...">

                    </textarea>

                </div>

                <!-- ارسال پیام درون برنامه ای -->
                
                <div class="form-check form-switch m-0 d-flex align-items-center col-12 p-1">

                    <input class="form-check-input m-0" type="checkbox" id="bSendPush" [ngModel]="false" name="bSendPush">
                
                    <label class="form-check-label pointer text-muted me-2" for="bSendPush"> ارسال پیام درون برنامه ای </label>
                
                </div>

                <!-- ثبت پیام در کارتابل -->

                <div class="form-check form-switch m-0 d-flex align-items-center col-12 p-1">

                    <input class="form-check-input m-0" type="checkbox" id="bSaveMessage" [ngModel]="false" name="bSaveMessage">
                
                    <label class="form-check-label pointer text-muted me-2" for="bSaveMessage"> ثبت پیام در کارتابل </label>
                
                </div>

                <!-- همراه با مبلغ بدهکاری -->

                <div class="form-check form-switch m-0 d-flex align-items-center col-12 p-1">

                    <input class="form-check-input m-0" type="checkbox" id="bWithDebit"[ngModel]="false" name="bWithDebit">
                
                    <label class="form-check-label pointer text-muted me-2" for="bWithDebit"> همراه با مبلغ بدهکاری </label>
                
                </div>

            </div>

            <div class="modal-footer">

                <button class="btn btn-primary" type="submit"> 

                    &nbsp; ارسال &nbsp;
                    
                </button>

            </div>

        </form>

    </div>
    
</div>